'use client'

import React, { FC, ReactElement } from 'react'
import styles from './CopyButton.module.css'
import classNames from 'classnames'
import Tooltip from '@mui/material/Tooltip'

import copy from 'copy-to-clipboard'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const CopyButton: FC<{
	value: string
	isUrl?: boolean
	label?: string
	className?: string
	copiedClassName?: string
	iconClassName?: string
	copyLabelClassName?: string
	tooltip?: string
	icon?: React.ReactNode
}> = (props): ReactElement => {
	const [open, setOpen] = React.useState(false)
	const _handleClose = React.useCallback(() => setOpen(false), [])

	const handleCopy = (evt: any) => {
		evt.preventDefault()
		evt.stopPropagation()

		let value = props.value

		if (props.isUrl) {
			value = `${window.location.origin}${value}`
		}

		setOpen(true)
		copy(value)
		setTimeout(() => setOpen(false), 1500)
	}

	const body = (
		<div
			className={classNames(styles.root, { [props?.className as any]: !!props?.className })}
			onClick={handleCopy}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(handleCopy)}
		>
			{!open && props.label && (
				<p className={classNames(styles.copyLabel, 'text-sm', props.copyLabelClassName)}>
					{props.label}
				</p>
			)}
			{open && (
				<p
					className={classNames(
						{ [props.copiedClassName as any]: !!props.copiedClassName },
						styles.copied,
						'text-sm',
						'medium'
					)}
				>
					Copied!
				</p>
			)}
		</div>
	)

	if (props.tooltip) {
		return (
			<Tooltip placement="top" title={props.tooltip}>
				{body}
			</Tooltip>
		)
	}

	return body
}

export default CopyButton
